// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

// LiveKit is the planned BACKUP voice transport. This stub exists so the swap point is
// explicit and typed: implement these methods against the LiveKit web SDK, then have
// create-voice-transport return it (gated by VITE_VOICE_TRANSPORT=livekit). No other
// file — controller or UI — changes, because everything depends only on VoiceTransport.

import type {
  VoiceCredentials,
  VoiceTransport,
  VoiceTransportHandlers,
} from '../types'

export class LiveKitVoiceTransport implements VoiceTransport {
  readonly name = 'livekit' as const

  isSupported(): boolean {
    return false
  }

  start(credentials: VoiceCredentials, handlers: VoiceTransportHandlers): Promise<void> {
    void credentials
    void handlers
    return Promise.reject(
      new Error('LiveKitVoiceTransport is not implemented yet (Vapi is the primary transport).'),
    )
  }

  sendText(text: string): void {
    void text
    throw new Error('LiveKitVoiceTransport is not implemented yet.')
  }

  setMuted(muted: boolean): void {
    void muted
  }

  isMuted(): boolean {
    return false
  }

  stop(): void {
    /* not implemented */
  }
}
